var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('el-pagination',{attrs:{"layout":"slot,prev, pager, next","background":"","current-page":_vm.page,"page-size":_vm.pageSize,"hide-on-single-page":true,"total":_vm.total},on:{"current-change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }